import { useMemo } from 'react';

interface NumberSeparators {
    thousandSeparator: string;
    decimalSeparator: string;
}

const DEFAULT_SEPARATORS: NumberSeparators = {
    thousandSeparator: ',',
    decimalSeparator: '.',
};

const resolveLocale = (appLanguage: string, country: string): string => {
    if (typeof navigator === 'undefined') {
        return `${appLanguage}-${country.toUpperCase()}`;
    }
    const browserLanguage = navigator.language?.split('-')[0];
    return browserLanguage && browserLanguage === appLanguage ? navigator.language : `${appLanguage}-${country.toUpperCase()}`;
};

export const useNumberSeparators = (appLanguage = 'en', country = 'US'): NumberSeparators =>
    useMemo(() => {
        if (typeof Intl === 'undefined') {
            return DEFAULT_SEPARATORS;
        }

        const locale = resolveLocale(appLanguage, country);
        const parts = new Intl.NumberFormat(locale).formatToParts(1234567.89);

        const thousandSeparator = parts.find((part) => part.type === 'group')?.value ?? DEFAULT_SEPARATORS.thousandSeparator;
        const decimalSeparator = parts.find((part) => part.type === 'decimal')?.value ?? DEFAULT_SEPARATORS.decimalSeparator;

        return { thousandSeparator, decimalSeparator };
    }, [appLanguage, country]);
